export function app() {
    return {
        overflowHidden: false,
        lightbox: false,

        init() {}
    };
}
